import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Injeta token em todas as requisições autenticadas
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('licmab_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redireciona para login se token expirar
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('licmab_token');
      localStorage.removeItem('licmab_usuario');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default api;
